import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import './EmailVerification.css';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setError('No verification token provided');
        return;
      }

      try {
        const response = await authAPI.verifyEmail(token);
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
      } catch (error) {
        setStatus('error');
        if (error.response?.data?.detail) {
          setError(error.response.data.detail);
        } else {
          setError('Failed to verify email. Please try again.');
        }
      }
    };

    verifyEmail();
  }, [searchParams]);

  if (status === 'verifying') {
    return (
      <div className="email-verification-container">
        <div className="verification-loading">
          <div className="spinner"></div>
          <h2>Verifying Your Email</h2>
          <p>Please wait while we verify your email address...</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="email-verification-container">
        <div className="verification-success">
          <div className="success-icon">✓</div>
          <h2>Email Verified Successfully!</h2>
          <p>{message}</p>
          <p>You can now log in to your account and start using SortaFriends.</p>
          <div className="verification-actions">
            <a href="/login" className="login-button">
              Go to Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="email-verification-container">
      <div className="verification-error">
        <div className="error-icon">✗</div>
        <h2>Verification Failed</h2>
        <p className="error-message">{error}</p>
        <p>This could be because:</p>
        <ul>
          <li>The verification link has expired</li>
          <li>The link has already been used</li>
          <li>The link is invalid</li>
        </ul>
        <div className="verification-actions">
          <a href="/register" className="register-button">
            Register Again
          </a>
          <a href="/login" className="login-button">
            Go to Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification; 